module.exports = __webpack_public_path__ + "static/media/contact_bg.2fc1fff2.png";